import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { getChemical, updateChemical } from 'slice/chemicalSlice';
import { deleteRequest } from 'apis/ApiInstence';
import AdminTable from 'common/AdminTable';
import TruncatedMessage from 'common/TruncatedMessage';
import Swal from 'sweetalert2';
import { toast } from 'react-toastify';

const ChemicalList = () => {
    const dispatch = useDispatch();
    const chemicalData = useSelector((state) => state.chemical);
    const [showModal, setShowModal] = useState(false);
    const [currentChemical, setCurrentChemical] = useState(null);
    const [imageFile, setImageFile] = useState(null);

    useEffect(() => {
        dispatch(getChemical());
    }, [dispatch]);

    const handleEditClick = (chemical) => {
        setCurrentChemical(chemical);
        setShowModal(true);
    };

    const handleCloseModal = () => {
        setShowModal(false);
        setCurrentChemical(null);
        setImageFile(null);
    };

    const handleSave = () => {
        const formData = new FormData();
        formData.append('name', currentChemical.name);
        formData.append('description', currentChemical.description);
        formData.append('is_active', currentChemical.is_active);
        formData.append('price', currentChemical?.price);
        formData.append('unit', currentChemical?.unit);
        formData.append('stock_quantity', currentChemical?.stock_quantity);

        if (imageFile) {
            formData.append('image', imageFile);
        }
        dispatch(updateChemical({ id: currentChemical.id, data: formData }));
        toast('Chemical Updated Successfully!')
        handleCloseModal();
    };

    const handleRemove = (id) => {
        Swal.fire({
            title: "Are you sure?",
            text: "You won't be able to revert this!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#d33",
            cancelButtonColor: "#3085d6",
            confirmButtonText: "Yes, delete it!",
        }).then(async (result) => {
            if (result.isConfirmed) {
                await deleteRequest(`chemical/${id}`);
                dispatch(getChemical());
                Swal.fire("Deleted!", "The chemical has been removed.", "success");
            }
        });
    };

    const handleImageChange = (event) => {
        setImageFile(event.target.files[0]);
    };

    const tableHeaders = [
        {
            Header: 'ID',
            accessor: 'id',
        },
        {
            Header: 'Image',
            accessor: 'image',
            Cell: ({ row }) => (
                <img
                    src={`${process.env.REACT_APP_BACKEND}asserts/chemical/${row.original.images}`}
                    alt={row.original.name}
                    width={100}
                />
            ),
        },
        {
            Header: 'Name',
            accessor: 'name',
        },
        {
            Header: 'Unit',
            accessor: 'unit',
        },
        {
            Header: 'Price',
            accessor: 'price',
        },
        {
            Header: 'Stock Qty',
            accessor: 'stock_quantity',
        },
        {
            Header: 'Created Date',
            accessor: 'createdAt',
        },
        {
            Header: 'Description',
            accessor: 'description',
            Cell: ({ row }) => <TruncatedMessage text={row.original.description} maxLength={30} />
        },
        {
            Header: 'Active',
            accessor: 'is_active',
            Cell: ({ row }) => (
                <span className={row.original.is_active ? 'badge badge-success' : 'badge badge-danger'}>
                    {row.original.is_active ? 'Active' : 'Inactive'}
                </span>
            ),
        },
        {
            Header: 'Actions',
            accessor: 'actions',
            Cell: ({ row }) => (
                <>
                    <button
                        className="btn removebtn mx-1 my-1"
                        onClick={() => handleRemove(row.original.id)}
                    >
                        Remove
                    </button>
                    <button
                        className="btn editbtn mx-1 my-1"
                        onClick={() => handleEditClick(row.original)}
                    >
                        Edit
                    </button>
                </>
            ),
        },
    ];

    return (
        <>
            <div className="container-fluid mt-5 ">
                <div className="mainheadig mx-4">
                    <h4 className="text-white font-weight-bold">Chemical List</h4>
                </div>
                {chemicalData?.data?.length > 0 && (
                    <AdminTable tableHeaders={tableHeaders} tableData={chemicalData.data} />
                )}
            </div>

            {showModal && currentChemical && (
                <div className="modal fade show" style={{ display: 'block' }} tabIndex="-1" role="dialog" aria-labelledby="editModalLabel" aria-hidden="true">
                    <div className="modal-dialog modal-dialog-centered" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title" id="editModalLabel">Edit Chemical</h5>
                                <button type="button" className="close" onClick={handleCloseModal} aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div className="modal-body">
                                <form>
                                    <div className="form-group">
                                        <label htmlFor="chemicalStatus">Status</label>
                                        <select defaultValue={currentChemical.is_active} onChange={(e) => setCurrentChemical({ ...currentChemical, is_active: e.target.value })} className="form-control" id="chemicalStatus">
                                            <option value={true}>Active</option>
                                            <option value={false}>Inactive</option>
                                        </select>
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="chemicalName">Name</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            id="chemicalName"
                                            value={currentChemical.name}
                                            onChange={(e) => setCurrentChemical({ ...currentChemical, name: e.target.value })}
                                        />
                                    </div>

                                    <div className="form-group">
                                        <label htmlFor="chemicalPrice">Price</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            id="chemicalPrice"
                                            value={currentChemical.price}
                                            onChange={(e) => setCurrentChemical({ ...currentChemical, price: e.target.value })}
                                        />
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="chemicalUnit">Unit</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            id="chemicalUnit"
                                            value={currentChemical.unit}
                                            onChange={(e) => setCurrentChemical({ ...currentChemical, unit: e.target.value })}
                                        />
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="chemicalStock">Stock Quantity</label>
                                        <input
                                            type="number"
                                            className="form-control"
                                            id="chemicalStock"
                                            value={currentChemical.stock_quantity}
                                            onChange={(e) => setCurrentChemical({ ...currentChemical, stock_quantity: e.target.value })}
                                        />
                                    </div>

                                    <div className="form-group">
                                        <label htmlFor="chemicalDescription">Description</label>
                                        <textarea
                                            className="form-control"
                                            id="chemicalDescription"
                                            value={currentChemical.description}
                                            onChange={(e) => setCurrentChemical({ ...currentChemical, description: e.target.value })}
                                        />
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="updateImage">Update Image</label>
                                        <input type='file' name='image' className='form-control' onChange={(e) => handleImageChange(e)} />
                                        {
                                            imageFile && (
                                                <img src={URL.createObjectURL(imageFile)} alt='chemical' className='img-fluid' />
                                            )
                                        }
                                    </div>
                                </form>
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" onClick={handleCloseModal}>Close</button>
                                <button type="button" className="btn btn-primary" onClick={handleSave}>Save changes</button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
}

export default ChemicalList;
